import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = 'QUIERO EMPEZAR A COBRAR EN DÓLARES AHORA',
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      trackAddToCart();
      window.open(href, '_blank');
    } else {
      document.getElementById('precio')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className={`
        relative group overflow-hidden rounded-full 
        bg-emerald-500 hover:bg-emerald-400 
        text-white font-bold text-sm md:text-lg lg:text-xl
        py-4 px-6 md:px-10 
        shadow-[0_0_20px_rgba(16,185,129,0.4)]
        hover:shadow-[0_0_30px_rgba(16,185,129,0.6)]
        transition-all duration-300
        flex items-center justify-center gap-2
        w-full md:w-auto
        ${className}
      `} data-id="element-19">
      <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-20" />
      <Zap className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-21" />
      <span className="relative z-10 uppercase tracking-wide text-center" data-id="element-22">
        {text}
      </span>
    </motion.button>;
}